import React from 'react'
import Layout from '../../components/layout/Layout'
import InactiveUsersTable from '../../elements/tables/users/InactiveUsersTable'

export default function InactiveUsers() {
  return (
    <div>
      <Layout>
        <InactiveUsersTable />
      </Layout>
    </div>
  )
}
